export default "__VITE_ASSET__Cgaoq303__"